import React, { useState, useEffect } from "react"
import MDBox from "components/MDBox"
import MDButton from "components/MDButton"
import MDTypography from "components/MDTypography"
import { Card } from "@mui/material"
import BasicLayout from "../components/BasicLayout"
import { authResetPassword } from "../../api/auth_reset_password"
import { Link } from "react-router-dom"
import { useNavigate } from "react-router-dom"
import { useLoading } from "../LoadingContext"

const LockPage: React.FC = () => {
  const { startLoading, stopLoading } = useLoading()
  const [errorMessage, setErrorMessage] = useState<string>("")
  const [mail, setMail] = useState<string | null>("")
  const navigate = useNavigate()
  const [isFinish, setIsFinish] = useState<boolean>(false)

  useEffect(() => {
    const data = localStorage.getItem("mail")
    setMail(data)
  }, [])

  const handleSubmit = async () => {
    try {
      if (mail) {
        startLoading()
        await authResetPassword(mail, 1)
        setErrorMessage("")
        setIsFinish(true)
        setTimeout(() => {
          navigate("/login")
        }, 5000)
      }
    } catch (error: any) {
      setErrorMessage("サーバーへの接続に失敗しました")
      //console.log(error)
    } finally {
      stopLoading()
    }
  }

  return (
    <BasicLayout>
      <Card>
        {!isFinish ? (
          <>
            <MDBox textAlign="center" pt={6} pb={4}>
              <MDTypography variant="h4" fontWeight="medium" mb={3}>
                アカウントロック
              </MDTypography>
            </MDBox>
            <MDBox px={6} pb={4}>
              <MDBox component="form" role="form">
                <MDBox mb={1}>アカウントがロックされています</MDBox>
                <MDBox mb={2} textAlign="center">
                  <MDTypography fontWeight="bold">{mail}</MDTypography>
                </MDBox>
                {errorMessage && (
                  <MDBox mb={2} color="error.main" fontSize="0.75rem" textAlign="center">
                    {errorMessage}
                  </MDBox>
                )}
                <MDBox textAlign="center" sx={{ mt: 3, mb: 2 }}>
                  <MDButton
                    variant="contained"
                    color="primary"
                    fullWidth
                    sx={{
                      borderRadius: "4px",
                      textTransform: "none",
                      fontSize: "1rem",
                      padding: "0.75rem 0"
                    }}
                    onClick={() => {
                      handleSubmit()
                    }}
                  >
                    ロック解除要求
                  </MDButton>
                </MDBox>
                <MDBox textAlign="right">
                  <MDTypography
                    component={Link}
                    to="/login"
                    variant="button"
                    color="info"
                    sx={{ textDecoration: "none", pr: 2 }}
                  >
                    戻る
                  </MDTypography>
                </MDBox>
              </MDBox>
            </MDBox>
          </>
        ) : (
          <>
            <MDBox textAlign="center" pt={6} pb={4}>
              <MDTypography variant="h4" fontWeight="medium" mb={3}>
                アカウントロック解除要求完了
              </MDTypography>
            </MDBox>
            <MDBox px={6} pb={4}>
              <MDBox textAlign="center" mb={2}>
                アカウントのロック解除を要求しました
              </MDBox>
              <MDBox mb={2} textAlign="center">
                <MDTypography fontWeight="bold">{mail}</MDTypography>
              </MDBox>
              <MDBox textAlign="right">
                <MDTypography
                  component={Link}
                  to="/login"
                  variant="button"
                  color="info"
                  sx={{ textDecoration: "none" }}
                >
                  戻る
                </MDTypography>
              </MDBox>
            </MDBox>
          </>
        )}
      </Card>
    </BasicLayout>
  )
}

export default LockPage
